const Form094EN = {
    stepName: {
        importantNotes: "Important Notes",
        applicationInformation: "Application Information",
        confirmation: "Confirmation",
    },
    label: {
        header: {
            headerOne: "Important Notes",
        },
        // statement:
        //     "I have read and understood the “Personal Information Collection Statement”.",
        statement:
            'I have read the "Personal Information Collection Statement" and fully understand its content.',
        iamStatement:
            'I understand that an "iAM Smart+" account is required for processing the application.',

        schoolSessionOption: {
            am: "AM",
            pm: "PM",
            wholeDay: "Whole Day",
        },
        title: "Please read the attached Personal Information Collection Statement carefully before completing this form.",
        information: "Basic Information",
        serial: "Serial No.",
        nameOfSchool: "Name of School",
        schoolCode: "School Code",
        schoolSession: "School Session",
        schoolTelephoneNo: "School Telephone No.",
        nameOfStaffEn: "Name of Teacher (in full) (English)",
        nameOfStaffCh: "Name of Teacher (in full) (Chinese)",
        staffReference: "Staff Reference No.",
        descriptionOfChangeOrDiscrepancy: "Description of Change / Discrepancy",
        informationInSalariesGrantReport:
            "Information in Salaries Grant Report",
        correctData: "Correct Data",
        refOfSchoolDevelopmentOfficerApproval:
            "Ref. of School Development Officer's Approval (if any)",
        dateOfSchoolDevelopmentOfficerApproval:
            "Date of School Development Officer's Approval (if any)",
        notificationOfTermination:
            "For Notification of Termination of Service, please provide the following data",
        lastDateOfEmployment: "Last Date of Employment",

        terminationReasonCode: "Termination Reason",
        terminationReasonCodeOption: {
            1: "Resignation",
            2: "Retirement",
            3: "Completion of Contract",
            4: "Termination of Contract before mature date",
            5: "Dismissal",
            6: "Death",
            7: "Others",
        },
        others: "Others (please specify)",
        payment: "Is payment in lieu of sufficient notice required?",
        paymentOption: {
            yes: "Yes",
            no: "No",
        },
        amount: "If Yes, Amount",
        amount1: "Amount",
        name: "Name",
        post: "Post",
        postOption: {
            schoolHead: "School Head",
            supervisor: "Supervisor",
        },
        supervisorOrHeadOfSchoolName: "Supervisor/Head of School Name",
    },
    importantNotesContent: {
        // note1: "Personal Information Collection Statement",
        // note2: "The personal data provided in this form will be used by the Education Bureau for one or more of the following purpose(s):",

        // note16: "processing employment-related matters;",
        // note17: "processing Salaries Grant payment and calculation of provident fund contribution and donation;",
        // note18: "auditing;",
        // note19: "conducting research and compiling statistics to facilitate planning of education services;",
        // note20: "processing matters relating to the development of the education profession;",
        // note21: "administering and enforcing the Education Ordinance and Regulations and the Grant/Subsidized Schools Provident Fund Rules(Cap. 279).",
        // note22: "The provision of personal data by means of this form is obligatory. Failure to provide these data may affect the processing and outcome of your application.",
        // note23: "The personal data collected in this form may be disclosed to other government bureaux/departments/agencies authorized to process such information for the purposes mentioned above.",
        // note24: "You have a right to request access to and correction of your personal data as provided in Sections 18 and 22 and Data Protection Principle 6 of Schedule 1 of the Personal Data (Privacy) Ordinance. Your right of access includes the right to obtain a copy of your personal data provided in this form. This is however subject to payment of a fee.",
        // note25: "Enquiries concerning the personal data collected by means of this form, including making of access and corrections, should be made in writing to Accounting Officer I of Funds Section, Education Bureau.",
        // five page
        title: "Personal Information Collection Statement",
        p_title: "Purpose of Collection",
        p1_1: "The personal data provided by you in this form will be used by the EDB for one or more of the following purposes:",
        p1_a: "Activities relating to the processing, authentication and counter-checking of employment-related matters including appointments, training and career developments, remuneration and benefits, staff relation, communications and compliance with procedures;",
        p1_b: "Activities relating to matching of the personal data with the database of relevant Government bureaux / departments in connection with the processing, authentication and counter-checking of employment-related matters mentioned in (a) above;",
        p1_c: "Activities relating to matching of the personal data within the database of EDB for purposes of verifying / updating records of the EDB, and",
        p1_d: "Activities relating to compilation of statistics, research and Government publications.",

        p2: "The provision of personal data required by this form and during the processing of this form is obligatory.  In the event that you do not provide those personal data, we may not be able to handle or further process the form.",

        p_title3: "Classes of Transferees",
        p3_1: "The personal data you provide will be made available to persons working in EDB.  Apart from this, they may be transferred or disclosed to the parties or in the circumstances listed below:-",
        p3_a: "other Government bureau and departments for the purposes mentioned in paragraph 1 above;",
        p3_b: "personnel, agent, service provider or organisations engaged by EDB to provide services or advice for the purposes mentioned in paragraph 1 above;",
        p3_c: "where you have given your prescribed consent to such disclosure; and",
        p3_d: "where such disclosure is authorised or required under the law or court order applicable to Hong Kong.",

        p_title4: "Access to Personal Data",
        p4: "You have the right to request access to and correction of your personal data held by EDB.  Request for access or correction of personal data should be made in writing to:",
        p4_1: "Accounting Officer I (Funds)1</br>Funds Section</br>Education Bureau</br>Room 1517, Wu Chung House, 213 Queen's Road East, Wan Chai, Hong Kong",
    },

    errorMsg: {
        englishName: "Please input a valid name of teacher in English",
        chineseName: "Please input a valid name of teacher in Chinese",
        numberOnly: "Please input a valid number with 8 digits",
        monthlySalary: "Please input a valid  monthly salary",
        rank: "Please input a valid rank ",
        // monthlySalary1: "Please input a valid substantive rank",
        // rank1: "Please input a valid rank of acting appointment",
        refNum: "Please input a valid reference number",
        hkidEmpty: "The value in the brackets cannot be empty",
        Note001:
            "Note 1.All the necessary procedures for promoting a staff or making acting appointment should be completed before the effective date, including the approval by the SMC/IMC.  Under normal circumstances, there should be no retrospective effect for the date of promotion and acting appoint.",
        telMax: "Telephone number must be at most 8 digits",
        srnMin: "Staff reference number must be 8 digits",
        schoolCodeMin: "School code must be 4 digits",
        min: "Please input a valid price",
        max: "Maximum price is 10",
        maxDecimal: "Price must be at most 2 decimal places",
        maxDigit: "The maximum decimal places 2",
        amountMin: "The minimum value of this field is 0",
        validAmount: "Please enter a valid amount",
    },
};
export default Form094EN;
